module.exports = __webpack_public_path__ + "img/4.3a1eb4d4.jpg";